import { asciiTextValidation } from 'framework/form';

const projectPlannedLeavesValidationSchema = {
  teamPlannedLeaves: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        id: {
          type: 'string',
          required: false,
        },
        employeeAlias: {
          type: 'string',
          required: true,
        },
        startDate: {
          type: {
            value: 'date',
            message: 'Please, enter a valid date',
          },
          required: true,
          maxDate: [
            {
              value: '$projectEndDate',
              when: [
                {
                  $hasProjectBudget: {
                    eq: true,
                  },
                },
                {
                  $projectEndDate: {
                    notEmpty: true,
                  },
                },
              ],
              message: 'Please choose date before or at project end date',
            },
          ],
        },
        endDate: {
          type: {
            value: 'date',
            message: 'Please, enter a valid date',
          },
          required: true,
          minDate: [
            {
              value: '$.startDate',
              message: "End date can't be earlier than start date",
              when: [
                {
                  '$.startDate': {
                    notEmpty: true,
                  },
                },
              ],
            },
          ],
          maxDate: [
            {
              value: '$projectEndDate',
              when: [
                {
                  $hasProjectBudget: {
                    eq: true,
                  },
                },
                {
                  $projectEndDate: {
                    notEmpty: true,
                  },
                },
              ],
              message: 'Please choose date before or at project end date',
            },
          ],
        },
        comment: {
          type: 'string',
          required: false,
          maxSize: 255,
          ...asciiTextValidation,
        },
      },
    },
  },
};

export default projectPlannedLeavesValidationSchema;
